import React, {createContext, useState, useEffect, useMemo} from 'react';
import {useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';

const defaultValues = {
  history: [],
};

const Context = createContext(defaultValues);

export default Context;

export const RouterHistoryContextProvider = ({children}) => {
  const [routerHistory, setRouterHistory] = useState(defaultValues.history);
  const router = useLocation();

  useEffect(() => {
    if (!router?.pathname) return;

    const {pathname, search} = router;

    // build the full route path
    const newPath = `${pathname}${search}`.trim();

    setRouterHistory(previousHistory => [...previousHistory, newPath]);
  }, [router?.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const values = useMemo(() => {
    /**
     * resets the router history to the default state.
     *
     * @return  {void}
     */
    const resetRouterHistory = () => {
      setRouterHistory(defaultValues.history);
    };

    return {
      routerHistory,
      resetRouterHistory,
    };
  }, [routerHistory]);

  return <Context.Provider value={values}>{children}</Context.Provider>;
};

RouterHistoryContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
